import { ActionMessage, DispatchFunction } from 'satcheljs';
import { ActionFunction, LegacyDispatchFunction, ActionContext } from 'satcheljs/lib/legacy';
import { trace } from 'owa-trace';

const actionStack: string[] = [];

// Detects when legacy actions are dispatched inside a mutator; this will eventually be an error
// condition in satchel but we need to make sure our codebase is clean first.
// TODO: Remove this middleware once #52033 is fixed
export function strictMutatorMiddleware(
    next: LegacyDispatchFunction,
    action: ActionFunction,
    actionType: string,
    args: IArguments,
    actionContext: ActionContext
) {
    if ((window as any).__satchelGlobalContext.inMutator) {
        trace.error(
            `Mutators cannot dispatch legacy actions (${actionType}) ` +
                `(actions: ${actionStack.join(',')})`
        );
    }

    return next(action, actionType, args, actionContext);
}

export function actionStackMiddleware(next: DispatchFunction, actionMessage: ActionMessage) {
    actionStack.push(actionMessage.type);

    try {
        return next(actionMessage);
    } finally {
        actionStack.pop();
    }
}
